import { createContext } from 'react';

const RichTextContext = createContext<{
  fontSize: number;
  lineHeight: number;
}>({
  fontSize: 14,
  lineHeight: 14 * 1.25,
});

export default RichTextContext;
